'use strict';

var util = require('../../../util/property-util');

module.exports = /*@ngInject*/ ["ZabbixResourceService", "ProjectService", "ZabbixOverviewFactory", "$q", "MonitoringResource", function ZabbixIssueFactory(ZabbixResourceService, ProjectService, ZabbixOverviewFactory, $q, MonitoringResource) {
    var factory = {
        findIssues: findIssues,
        deleteAlarmEvent: deleteAlarmEvent,
        getZabbixIssues: findZabbixIssues,
        findIssuesByHashCode: findIssuesByHashCode,
        findNonGroupIssues: findNonGroupIssues,
        findNonGroupIssuesPerDeviceId: findNonGroupIssuesPerDeviceId,
        calculateCurrentHashCode: calculateCurrentHashCode,
        calculateCurrentIssues: calculateCurrentIssues,
        fillAcknowledgeSort: fillAcknowledgeSort,
        fetchIssues: fetchIssues,
        setFilteredIssues: setFilteredIssues,
        subscribe: subscribe,
        unsubscribe: unsubscribe,
        convertAlarmEventToIssue: convertAlarmEventToIssue,
        convertZabbixIssueToIssue: convertZabbixIssueToIssue
    };

    var allIssues = [];
    var filteredIssues = [];

    var subMap = new Map();

    return factory;

    /*
     FUNCTIONS
     */

    function convertAlarmEventToIssue(trainId, alarmEvent) {
        return {
            trainId: trainId,
            severity: alarmEvent.level,
            hostname: "" + ProjectService.getSelectedProjectId() + "_" + trainId + "_MAR3-B" + alarmEvent.boxId,
            boxId: alarmEvent.boxId,
            lastChange: alarmEvent.timestamp,
            description: alarmEvent.description,
            eventId: alarmEvent.id,
            type: 'nms-alarm',
            acknowledged: alarmEvent.acknowledged,
            incidentId: alarmEvent.incidentId
        };
    }

    function convertZabbixIssueToIssue(issues) {
        issues.forEach(function (issue) {
            issue.type = "zabbix-alarm";
        });
        return issues;
    }

    function findZabbixIssues(projectId, relativeTrainId) {
        var promise = $q.defer();

        ZabbixResourceService.structure().get({
            projectId: projectId,
            trainId: relativeTrainId
        }).$promise.then(function (data) {

            if(util.isDefined(data.devices)){
                data.devices.forEach(function (device) {
                    device.issues = convertZabbixIssueToIssue(device.issues);
                });
            }
            promise.resolve(data);

        });

        return promise.promise;
    }

    function deleteAlarmEvent(projectId, description, relativeTrainId, boxId) {
        var promise = $q.defer();

        MonitoringResource.deleteAlarm(projectId, description, relativeTrainId, boxId).delete().$promise.then(function (data) {
            promise.resolve();
        }, function(err){
            promise.reject();
        });

        return promise.promise;
    }


    function findIssues(data, level) {
        "use strict";
        var issues = [];

        if (level === "train") {
            if (util.isDefined(data.devices)) {
                data.devices.forEach(function (device) {
                    issues = issues.concat(device.issues);
                });
            }
            if (util.isDefined(data.deviceGroups)) {
                data.deviceGroups.forEach(function (deviceGroups) {
                    deviceGroups.devices.forEach(function (device) {
                        issues = issues.concat(device.issues);
                    });
                });
            }
        } else if (level === "deviceGroup") {
            if (util.isDefined(data.devices)) {
                data.devices.forEach(function (device) {
                    issues = issues.concat(device.issues);
                });
            }
        }
        else if (level === "device") {
            issues = data.issues;
        }

        return issues;
    }



    function findIssuesByHashCode(structure, hashCode) {
        "use strict";
        var issues = [];
        structure.some(function (train) {
            if (train.hashCode === hashCode) {
                issues = factory.findIssues(train, "train");
                return true;
            }

            train.devices.some(function (device) {
                if (device.hashCode === hashCode) {
                    issues = device.issues;
                    return true;
                }
            });

            train.deviceGroups.some(function (deviceGroup) {
                if (deviceGroup.hashCode === hashCode) {
                    issues = factory.findIssues(deviceGroup, "deviceGroup");
                    return true;
                }

                deviceGroup.devices.some(function (device) {
                    if (device.hashCode === hashCode) {
                        issues = device.issues;
                        return true;
                    }
                });
            });
        });
        return issues;
    }

    function findNonGroupIssues(train) {
        "use strict";
        var issues = [];
        train.devices.forEach(function (device) {
            issues = issues.concat(device.issues);
        });

        return issues;
    }

    function findNonGroupIssuesPerDeviceId(train, deviceId) {
        "use strict";
        var issues = undefined;
        train.devices.forEach(function (device) {
            if (device.hostname == deviceId) {
                issues = device.issues;
            }
        });

        return issues;
    }

    function calculateCurrentHashCode(data, opened, level) {
        "use strict";
        var currentHashCode = data.hashCode;

        if (!opened && level === "train") {
            currentHashCode = undefined;
        }

        return currentHashCode;
    }

    function calculateCurrentIssues(issues, opened, level, allIssues) {
        "use strict";
        var currentIssues = [];

        if (level === "train") {
            if (opened) {
                currentIssues = issues;
            } else {
                currentIssues = allIssues;
            }
        } else if (level === "device") {
            currentIssues = issues;
        } else if (level === "deviceGroup") {
            if (opened) {
                currentIssues = issues;
            }
        }
        return currentIssues;
    }

    function fillAcknowledgeSort(issues) {
        "use strict";
        var updatedIssues = [];

        issues.forEach(function (issue) {
            if (!util.isDefined(issue.acknowledged)) {
                issue.acknowledgedSort = 2;
            }
            else if (issue.acknowledged) {
                issue.acknowledgedSort = 3;
            }
            else if (!issue.acknowledged) {
                issue.acknowledgedSort = 1;
            }
            updatedIssues.push(issue);
        });
        return updatedIssues;
    }

    function setFilteredIssues(fIssues) {
        filteredIssues = fIssues;
        notifySubscribers();
    }

    function notifySubscribers() {
        subMap.forEach(function (value, key) {
            value(filteredIssues);
        });
    }

    function fetchIssues(callback) {
        allIssues = [];

        ZabbixResourceService.trainStructure().query({projectId: ProjectService.getSelectedProjectId()}).$promise.then(function (data) {
            "use strict";
            var trainStructures = [];
            var proxyUpDate = ZabbixOverviewFactory.adjustOfflineProxyPriorities(data);
            var structureData = ZabbixOverviewFactory.makeStructure(proxyUpDate);
            var orderedData = ZabbixOverviewFactory.orderData(structureData);
            var structure = ZabbixOverviewFactory.fillHashCodes(orderedData);
            trainStructures = ZabbixOverviewFactory.fillPriorities(structure);

            trainStructures.forEach(function (train) {
                var issues = findIssues(train, "train");
                var issuesWithSorting = fillAcknowledgeSort(issues);

                allIssues = allIssues.concat(issuesWithSorting);
            });

            callback(allIssues);
            notifySubscribers();

        });

    }

    function subscribe(name, callback) {
        subMap.set(name, callback);
        callback(filteredIssues);
    }

    function unsubscribe(name) {
        subMap.delete(name);
    }
}];
